import { Calendar } from "primereact/calendar";
import { useState, useEffect } from "react";
import IconCalendar from "../SvgIcon/IconCalendar";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

export default function UserFilter({ onDateFilter, activeTab }) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const [dates, setDates] = useState(null);

  // ✅ Sync with tab changes
  useEffect(() => {
    let defaultRange = null;

    if (activeTab === "today") {
      defaultRange = [today, today];
    }

    if (activeTab === "previous") {
      defaultRange = [yesterday, yesterday];
    }

    if (activeTab === "upcoming") {
      defaultRange = [tomorrow, tomorrow];
    }

    setDates(defaultRange);

    onDateFilter(
      defaultRange ? defaultRange[0] : null,
      defaultRange ? defaultRange[1] : null
    );
  }, [activeTab]);

  // ✅ Handle manual selection
  const handleDateChange = (e) => {
    const value = e.value;
    setDates(value);

    if (Array.isArray(value)) {
      const [start, end] = value;

      if (start && end) {
        onDateFilter(start, end);
      } else if (start) {
        onDateFilter(start, start);
      } else {
        onDateFilter(null, null);
      }
    } else {
      onDateFilter(null, null);
    }
  };

  // ✅ IMPORTANT: REAL BLOCKING LOGIC
  const getMinMaxDates = () => {
    if (activeTab === "today") {
      return {
        minDate: today,
        maxDate: today,
      };
    }

    if (activeTab === "previous") {
      return {
        minDate: new Date(1900, 0, 1),
        maxDate: yesterday,
      };
    }

    if (activeTab === "upcoming") {
      return {
        minDate: tomorrow,
        maxDate: new Date(2100, 0, 1),
      };
    }

    return {
      minDate: null,
      maxDate: null,
    };
  };

  const { minDate, maxDate } = getMinMaxDates();

  return (
    <div className="calendar-area">
      <Calendar
        value={dates}
        onChange={handleDateChange}
        selectionMode="range"
        readOnlyInput
        className="calendarfilterdata"
        panelClassName="custom-calendar-panel"
        placeholder="Select Date Range"
        dateFormat="dd-mm-yy"
        showIcon
        icon={<IconCalendar />}

        // ✅ THIS FIXES EVERYTHING
        minDate={minDate}
        maxDate={maxDate}
      />
    </div>
  );
}